import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { tipoAjustesModuleName } from "../shared/data.service";
import { TipoAjuste } from "../shared/tipo-ajuste.model";
import {editRoute, newRoute, configuracaoModuleName} from "../../../shared/services/data.service";
import { TipoAjusteNavigationService } from "../shared/tipo-ajuste-navigation.service";
import { TipoAjusteApiService } from "../shared/tipo-ajuste-api.service";
import { UtilService } from "../../../shared/services/util.service";
import { TipoAjusteService } from "../shared/tipo-ajuste.service";
import { AbastecimentoService } from "../../shared/abastecimento.service";
import {abastecimentosModuleName} from "../../shared/data.service";

@Component({
    template: require('./tipo-ajuste-form.component.html'),
    styles: [require('./tipo-ajuste-form.component.css')]
})
export class TipoAjusteFormComponent implements OnInit {
    tipoAjustesModule: any = tipoAjustesModuleName;
    formObject: any = new TipoAjuste();
    actionTitle: string;
    submitted: boolean = false;
    btnSaveDisabled: boolean = false;
    module: any = abastecimentosModuleName;
    configuracaoModule: any = configuracaoModuleName;

    form: FormGroup;
    ativo = new FormControl('');
    tipo = new FormControl('', Validators.required);

    constructor(
        private _route: ActivatedRoute,
        private _TipoAjusteNavigationService: TipoAjusteNavigationService,
        private _TipoAjusteApiService: TipoAjusteApiService,
        private _TipoAjusteService: TipoAjusteService,
        private _utilService: UtilService,
        private _abastecimentoService: AbastecimentoService,

        private _fb: FormBuilder
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            tipo: this.tipo
        });
    }

    ngOnInit() {
        this.testSession();
    }

    clickGoToList() {
        this.goToList();
    }

    clickGoToSettings() {
        this._abastecimentoService.goToSetting();
    }

    clickCancel() {
        this.toLeaveHere();
    }

    onSubmit(evt: any) {
        this.submitted = true;
        if(evt.valid) {
            this.btnSaveDisabled = true;
            let object: TipoAjuste = this._utilService.cloneObject(this.formObject);

            if (this.formObject.id) {
                this.onEditTipoAjuste(object);
            } else {
                this.onAddTipoAjuste(object);
            }
        }
    }

    private onAddTipoAjuste(object: TipoAjuste) {
        this._TipoAjusteApiService.onPost(object, this.onDone);
    }

    private onEditTipoAjuste(object: TipoAjuste) {
        this._TipoAjusteApiService.onPut(object, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }

            this.toLeaveHere();

        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getObject(id: number) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;
                this.setModelToForm();
            } else {
                this._utilService.swalMessageWarningCustom('Nenhum tipo de ajuste encontrado com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._TipoAjusteApiService.onGetById(id, onDone);
    }

    private testSession() {
        let id: number;
        let session: any = this._TipoAjusteService.getSessionStorage();
        this._TipoAjusteService.clearSessionStorage();

        if (session) {
            this.formObject = session;
            id = session.id;
            this.setModelToForm();
        } else {
            id = +this._route.snapshot.params['id'];
            if (id) {
                this.setEditNormal(id);
            } else {
                this.setNewNormal();
            }
        }

        this.setActionTitle(id);
    }

    private setModelToForm() {

    }

    private toLeaveHere() {
        this.goToList();
    }

    private goToList() {
        this._TipoAjusteNavigationService.goToList();
    }

    private setActionTitle(id: number) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRoute;
        }
    }

    private setEditNormal(id: number) {
        this.getObject(id);
    }

    private setNewNormal() {

    }

    private setEditSession() {
        //qndo retornou para continuar a edição
    }

    private setNewSession() {
        //qndo retornou para continuar o cadastro
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/tipo-ajustes/tipo-ajuste-form/tipo-ajuste-form.component.ts
 **/